import _axios from "src/services";
import { ChecklistOption } from "src/types";

export const ChecklistOptionService = {
  delete: async (id: ChecklistOption["id"]): Promise<void> =>
    (await _axios.delete(`/checklist/option/${id}`)).data,
};

export default ChecklistOptionService;
